import { ProductsList } from '@/@types';
import ProductsListCharacteristicsCard from './ProductsListCharacteristicsCard';
import { FallbackImage } from '../common';
import Link from 'next/link';
import { ROUTES } from '@/config/routes';
import NoContent from '../common/NoContent';
import { Skeleton } from "@/components/ui/skeleton"

type Props = {
    products: ProductsList;
    unitType: "metric" | "english";
    industrySlug?: string;
    isLoading?: boolean;
};

export default function ProductsListCard({ products, unitType, industrySlug, isLoading }: Props) {
    if (isLoading) {
        return (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {[...Array(12)].map((_, index) => (
                    <div key={index} className="flex flex-col h-[400px] bg-white shadow overflow-hidden">
                        <div className="h-[280px] w-full flex items-center justify-center">
                            <Skeleton className="w-full h-full  rounded-none" />
                        </div>
                        <div className="h-[120px] p-4 bg-light00">
                            <Skeleton className="h-6 w-3/4 mb-2" />
                            <div className="space-y-2">
                                <Skeleton className="h-4 w-full" />
                                <Skeleton className="h-4 w-2/3" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        )
    }

    if (!products || products.products.length === 0) {
        return <NoContent message="No hay productos disponibles" />
    }

return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch">
        {products.products.map((product, index) => {
            
            return (
                <Link
                    href={ROUTES.products.productDetails(product.slug, industrySlug)}
                    key={product.slug}
                    className="flex flex-col bg-light00 shadow overflow-hidden hover:shadow-2xl transition"
                >
                    <div className="h-[280px] w-full flex items-center justify-center bg-white">
                        <FallbackImage
                            width={200}
                            height={200}
                            src={product.image || ''}
                            alt={product.short_name}
                            className="w-full h-full object-scale-down"
                            priority={index < 3}
                            sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                            quality={65}
                            loading="eager"
                            unoptimized={false}
                        />
                    </div>
                    <div className="p-4 bg-light00 flex flex-col justify-between flex-1">
                        <ProductsListCharacteristicsCard
                            characteristics={product.characteristics}
                            unitType={unitType}
                            productName={product.short_name}
                        />
                    </div>
                </Link>
            );
        })}
    </div>
);
}